import { HttpClient } from '@wix/http-client';
import { ErrorReporter } from '@wix/editor-error-reporter';
import { AI_IMAGE_GENERATION_SERVERLESS_BASE_URL } from './consts';
import { PromptsData } from './types';

interface PromptsRequestOptions {
  scenePromptVer: string;
  structurePromptVer: string;
  imageDescriptions: Record<string, object>;
  siteDescription?: string;
  businessTerm: string;
}

export const getPromptsKeysFromServerless = async (
  requestOptions: PromptsRequestOptions,
  msId: string,
  msInstance: string,
): Promise<{ results: PromptsData } | undefined> => {
  const httpClient = new HttpClient({
    headers: { Authorization: msInstance },
  });

  const url = `${AI_IMAGE_GENERATION_SERVERLESS_BASE_URL}prompts/?metaSiteId=${msId}`;

  return httpClient
    .post(url, requestOptions)
    .then(({ data }) => data)
    .catch((e) => {
      ErrorReporter.captureException(e, {
        tags: { aiImageGeneratorRequest: true },
        extra: { url, requestOptions },
      });
    });
};

export const getImageFromServerless = async (
  msInstance: string,
  promptKey: string,
  aspectRatio: string,
  imageGenerationPromptId: string,
  compId: string,
): Promise<{ url: string } | undefined> => {
  const httpClient = new HttpClient({
    headers: { Authorization: msInstance },
  });

  const url = `${AI_IMAGE_GENERATION_SERVERLESS_BASE_URL}image-by-prompt-object`;
  const requestOptions = {
    promptKey,
    aspectRatio,
    imageGenerationPromptId,
    compId,
    raw: true,
  };

  return httpClient
    .post(url, requestOptions)
    .then(({ data }) => data)
    .catch((e) => {
      ErrorReporter.captureException(e, {
        tags: {
          aiImageGeneratorRequest: true,
          aiImageGenerationServerless: true,
        },
        extra: { url, requestOptions },
      });
    });
};
